import { Form, InputControl, Picker } from "@venuepos/react-common";
import { IProductInput } from "lib";
import { useTranslation } from "locales";
import React from "react";

export const ParentPickerSection = React.memo(function ParentPickerSection({
    value,
    error,
    t,
    onParentChange,
    parentOptions,
    isExternal,
}: {
    value: IProductInput["parentId"];
    error: Form<IProductInput>[0]["errors"]["parentId"];
    t: ReturnType<typeof useTranslation>[0];
    onParentChange: (value: string) => void;
    parentOptions: Array<{ value: string; label: string }>;
    isExternal: boolean;
}) {
    return (
        <InputControl
            error={error}
            description={
                isExternal
                    ? `${t(
                          "backoffice.product_form.parent_description",
                          "If selected, the product becomes a sub-product of the selected parent product."
                      )} ${t(
                          "backoffice.common.readonly_value",
                          "This value is controlled by an external system via the API and can only be changed from here."
                      )}`
                    : t(
                          "backoffice.product_form.parent_description",
                          "If selected, the product becomes a sub-product of the selected parent product."
                      )
            }
        >
            <Picker
                label={t("backoffice.product_form.parent", "Parent product")}
                onValueChange={onParentChange}
                selectedValue={value || ""}
                disabled={isExternal}
            >
                <Picker.Item
                    label={t(
                        "backoffice.product_form.choose_parent",
                        "Choose a parent product"
                    )}
                    value=""
                />
                {parentOptions.map(option => (
                    <Picker.Item
                        key={option.value}
                        value={option.value}
                        label={option.label}
                    />
                ))}
            </Picker>
        </InputControl>
    );
});
